import { render, staticRenderFns } from "./ResourceEditTabAccount.vue?vue&type=template&id=82fa8ca4"
import script from "./ResourceEditTabAccount.vue?vue&type=script&lang=js"
export * from "./ResourceEditTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports